module.exports = __webpack_public_path__ + "img/swipe-helper.603bb285.gif";